import { Helmet } from 'react-helmet-async';
import ServicePage from './ServicePage';
import { useService } from '../hooks/usePublicApi';
import { serviceCategories } from '../data/services';

const staticData = serviceCategories.find((s) => s.id === 'sanierung');

export default function Sanierung() {
  const { service } = useService('sanierung');
  const data = service || staticData;

  return (
    <>
      <Helmet>
        <title>Sanierung & Renovierung | Süd Ausbau GmbH</title>
        <meta name="description" content="Fachgerechte Sanierung und Renovierung in München. Altbausanierung, Wasserschadensanierung und energetische Modernisierung — Süd Ausbau GmbH." />
        <link rel="canonical" href="https://sued-ausbau.de/sanierung" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sued-ausbau.de/sanierung" />
        <meta property="og:title" content="Sanierung & Renovierung | Süd Ausbau GmbH" />
        <meta property="og:description" content="Fachgerechte Sanierung und Renovierung in München. Altbausanierung, Wasserschadensanierung und energetische Modernisierung — Süd Ausbau GmbH." />
        <meta property="og:image" content="https://sued-ausbau.de/og-preview.png" />
      </Helmet>
      <ServicePage data={data} />
    </>
  );
}
